import { Component } from "react";
import api from "@/lib/api";

export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    api.post("/client-errors", { message: String(error?.message || error), stack: String(error?.stack || "").slice(0, 4000), component_stack: String(info?.componentStack || "").slice(0, 4000), url: window.location.href }).catch(() => {});
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="max-w-xl mx-auto my-16 card-tactical rounded-md p-8" data-testid="error-boundary">
        <div className="text-[10px] tracking-[0.3em] uppercase text-red-400">Something went wrong</div>
        <h2 className="font-display font-black text-3xl mt-2">This screen hit an error</h2>
        <p className="opacity-70 text-sm mt-3">The error has been reported automatically. You can go back to the calendar or reload the page.</p>
        <pre className="mt-4 text-[11px] opacity-60 whitespace-pre-wrap break-words max-h-40 overflow-auto" data-testid="error-boundary-message">{String(this.state.error?.message || this.state.error)}</pre>
        <div className="flex gap-2 mt-6">
          <button type="button" onClick={() => { this.setState({ error: null }); window.location.assign("/app/calendar"); }} className="btn-volt px-4 py-2 rounded-md text-xs tracking-widest uppercase" data-testid="error-boundary-home">Back to calendar</button>
          <button type="button" onClick={() => window.location.reload()} className="text-xs tracking-widest uppercase px-4 py-2 rounded border border-border" data-testid="error-boundary-reload">Reload</button>
        </div>
      </div>
    );
  }
}
